import SpellsFilterExclusiveCheckboxFilter from './SpellsFilterExclusiveCheckboxFilter';

export default SpellsFilterExclusiveCheckboxFilter;
export { SpellsFilterExclusiveCheckboxFilter };
